import createPlugin from "./createPlugin";
import USPBlockRenderer from "./Renderer";

const USPBlockPlugin = (settings) =>
    createPlugin({
        Renderer: USPBlockRenderer,
        Controls: () => null,
        ...settings,
    });

const USPBlock = USPBlockPlugin();
export default USPBlock;

export { USPBlockPlugin, USPBlockRenderer };
